import _regeneratorRuntime from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { embedResources } from './embed-resources';
import { toArray, isInstanceOfElement } from './util';
import { isDataUrl, resourceToDataURL } from './dataurl';
import { getMimeType } from './mimes';
function embedProp(_x, _x2, _x3) {
  return _embedProp.apply(this, arguments);
}
function _embedProp() {
  _embedProp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(propName, node, options) {
    var _a, propValue, cssString;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
          if (!propValue) {
            _context.next = 7;
            break;
          }
          _context.next = 4;
          return embedResources(propValue, null, options);
        case 4:
          cssString = _context.sent;
          node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
          return _context.abrupt("return", true);
        case 7:
          return _context.abrupt("return", false);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _embedProp.apply(this, arguments);
}
function embedBackground(_x4, _x5) {
  return _embedBackground.apply(this, arguments);
}
function _embedBackground() {
  _embedBackground = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(clonedNode, options) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return embedProp('background', clonedNode, options);
        case 2:
          if (_context2.sent) {
            _context2.next = 5;
            break;
          }
          _context2.next = 5;
          return embedProp('background-image', clonedNode, options);
        case 5:
          _context2.next = 7;
          return embedProp('mask', clonedNode, options);
        case 7:
          if (_context2.sent) {
            _context2.next = 10;
            break;
          }
          _context2.next = 10;
          return embedProp('mask-image', clonedNode, options);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _embedBackground.apply(this, arguments);
}
function embedImageNode(_x6, _x7) {
  return _embedImageNode.apply(this, arguments);
}
function _embedImageNode() {
  _embedImageNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(clonedNode, options) {
    var isImageElement, url, dataURL;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isImageElement = isInstanceOfElement(clonedNode, HTMLImageElement);
          if (!(!(isImageElement && !isDataUrl(clonedNode.src)) && !(isInstanceOfElement(clonedNode, SVGImageElement) && !isDataUrl(clonedNode.href.baseVal)))) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return");
        case 3:
          url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
          _context3.next = 6;
          return resourceToDataURL(url, getMimeType(url), options);
        case 6:
          dataURL = _context3.sent;
          _context3.next = 9;
          return new Promise(function (resolve, reject) {
            clonedNode.onload = resolve;
            clonedNode.onerror = reject;
            var image = clonedNode;
            if (image.decode) {
              image.decode = resolve;
            }
            if (image.loading === 'lazy') {
              image.loading = 'eager';
            }
            if (isImageElement) {
              clonedNode.srcset = '';
              clonedNode.src = dataURL;
            } else {
              clonedNode.href.baseVal = dataURL;
            }
          });
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _embedImageNode.apply(this, arguments);
}
function embedChildren(_x8, _x9) {
  return _embedChildren.apply(this, arguments);
}
function _embedChildren() {
  _embedChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(clonedNode, options) {
    var children, deferreds;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          children = toArray(clonedNode.childNodes);
          deferreds = children.map(function (child) {
            return embedImages(child, options);
          });
          _context4.next = 4;
          return Promise.all(deferreds).then(function () {
            return clonedNode;
          });
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _embedChildren.apply(this, arguments);
}
export function embedImages(_x10, _x11) {
  return _embedImages.apply(this, arguments);
}
function _embedImages() {
  _embedImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(clonedNode, options) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!isInstanceOfElement(clonedNode, Element)) {
            _context5.next = 7;
            break;
          }
          _context5.next = 3;
          return embedBackground(clonedNode, options);
        case 3:
          _context5.next = 5;
          return embedImageNode(clonedNode, options);
        case 5:
          _context5.next = 7;
          return embedChildren(clonedNode, options);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _embedImages.apply(this, arguments);
}